import PageHeader from "../components/PageHeader";
import { mentors } from "../lib/mockData";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";
import { Card } from "../components/ui/card";
import { Star, MapPin, Sparkles } from "lucide-react";
import { toast } from "sonner";

export default function Mentorship() {
  return (
    <>
      <PageHeader
        eyebrow="Mentorship"
        title="Real people. Hard-won wisdom."
        description="Get 1:1 guidance from mentors who've walked the path — from careers to college to first businesses."
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 pb-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mentors.map((m, i) => (
            <Card
              key={m.id}
              data-testid={`mentor-${m.id}`}
              className={`fade-up stagger-${(i % 6) + 1} rounded-3xl border-border/60 shadow-none p-6 hover:shadow-md transition-shadow`}
            >
              <div className="flex items-start gap-4 mb-4">
                <img
                  src={m.avatar}
                  alt={m.name}
                  className="h-16 w-16 rounded-2xl object-cover shrink-0"
                />
                <div className="flex-1 min-w-0">
                  <h4 className="font-display font-semibold truncate">{m.name}</h4>
                  <div className="flex items-center gap-1 text-xs text-muted-foreground mt-0.5">
                    <Star size={12} className="fill-secondary text-secondary" />
                    <span className="font-semibold text-foreground">{m.rating}</span>
                    <span>· {m.reviews} reviews</span>
                  </div>
                </div>
              </div>
              <Badge className="rounded-full bg-primary/10 text-primary border-0 text-[10px] mb-3">
                {m.field}
              </Badge>
              <p className="text-sm text-muted-foreground line-clamp-3 leading-relaxed">{m.bio}</p>
              <div className="mt-4 flex items-center gap-3 text-xs text-muted-foreground">
                <span className="flex items-center gap-1"><MapPin size={12} /> {m.location}</span>
                <span>· {m.experience}</span>
              </div>
              <Button
                onClick={() => toast.success(`Session requested with ${m.name}. Confirming shortly.`)}
                data-testid={`mentor-book-${m.id}`}
                className="rounded-full mt-5 w-full bg-secondary hover:bg-secondary/90 text-white"
              >
                <Sparkles size={14} className="mr-1.5" /> Book free session
              </Button>
            </Card>
          ))}
        </div>
      </div>
    </>
  );
}
